import axios from "axios";
import qs from "qs";
import React, { useEffect, useState } from "react";
import DecryptToken from "../utils/secure/DecryptToken";

export default function FetchData({ url, json, params, reload }) {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [data, setData] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    console.log("fetching data");
    axios
      .get(baseURL + url, {
        data: JSON.stringify(json),
        params: params,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          // console.log(res);
          const result = res.data.data;
          setData(result);
        } else {
          setError("Error Contact Administrator");
        }
      })
      .catch((e) => {
        console.log(e);
        if (e.status === 404) {
          setError("Data Kosong");
          return {
            data,
            error,
          };
        }
        console.log(e);
        setError(e);
      });
  }, [reload]);

  return {
    data,
    error,
  };
}
